import { useState } from 'react'

/**
 * Password input with a show/hide toggle (eye icon).
 * Accepts all standard input props. Renders the toggle absolutely positioned
 * inside the input padding-right.
 */
export default function PasswordInput({
  id,
  value,
  onChange,
  className = '',
  required,
  autoComplete = 'current-password',
  placeholder,
  ...rest
}) {
  const [visible, setVisible] = useState(false)
  return (
    <div className="relative">
      <input
        id={id}
        type={visible ? 'text' : 'password'}
        value={value}
        onChange={onChange}
        required={required}
        autoComplete={autoComplete}
        placeholder={placeholder}
        className={`pr-10 ${className}`}
        {...rest}
      />
      <button
        type="button"
        tabIndex={-1}
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? 'Nascondi password' : 'Mostra password'}
        className="absolute inset-y-0 right-0 px-3 flex items-center text-gray-500 hover:text-gray-700"
      >
        {visible ? (
          // eye-slash
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            className="w-5 h-5"
            aria-hidden="true"
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M3.98 8.22A10.48 10.48 0 0 0 1.93 12c1.7 3.4 5.32 6 10.07 6 1.83 0 3.5-.4 4.94-1.1M6.23 6.23A10.45 10.45 0 0 1 12 6c4.75 0 8.37 2.6 10.07 6a10.5 10.5 0 0 1-4.3 4.77M9.88 9.88a3 3 0 1 0 4.24 4.24" />
            <path strokeLinecap="round" strokeLinejoin="round" d="m3 3 18 18" />
          </svg>
        ) : (
          // eye
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            className="w-5 h-5"
            aria-hidden="true"
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z" />
            <circle cx="12" cy="12" r="3" />
          </svg>
        )}
      </button>
    </div>
  )
}
